import React from 'react';
import { motion } from 'framer-motion';
import { regions } from '../data/regions';
import { Reveal } from './Reveal';
export function Coverage() {
  const max = Math.max(...regions.map(r => r.taskers));
  return <section id="coverage" className="mx-auto grid max-w-6xl scroll-mt-20 gap-14 px-6 py-28 lg:grid-cols-[1fr_1.4fr]" data-id="element-15" data-mp="ifu587rb18wy">
      <Reveal data-id="element-16" data-mp="dmrcg1ucq3ht">
        <p className="font-display text-[7rem] font-semibold leading-none tracking-tighter text-accent md:text-[9rem]" data-id="element-17" data-mp="dlzgur0r85rj">150+</p>
        <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight" data-id="element-18" data-mp="ne5gmmx8zrha">Countries with nodes online right now.</h2>
        <p className="mt-4 max-w-sm text-muted" data-id="element-19" data-mp="11dwos7132dnd">
          38,800 verified humans. Every one ID-checked and rated after every task, so the proof you get back is proof you can actually trust.
        </p>
      </Reveal>

      <div className="self-end" data-id="element-20" data-mp="335t4lsuaa9ny">
        <table className="w-full text-left" data-id="element-21" data-mp="336upep13qaiv">
          <caption className="sr-only" data-id="element-22" data-mp="2y6zywml8nmyc">Tasker coverage by region</caption>
          <thead data-id="element-23" data-mp="3i5i62b3agkju">
            <tr className="border-b border-line font-mono text-xs text-muted" data-id="element-24" data-mp="3i61covnhnmik">
              <th scope="col" className="pb-3 font-normal" data-id="element-25" data-mp="3n433y3v2is54">region</th>
              <th scope="col" className="hidden pb-3 font-normal sm:table-cell" data-id="element-26" data-mp="3n28lqxb6le4q">active_taskers</th>
              <th scope="col" className="pb-3 text-right font-normal" data-id="element-27" data-mp="3s1csziejp1sf">countries</th>
              <th scope="col" className="pb-3 text-right font-normal" data-id="element-28" data-mp="q2y4x9usp00">p50_claim</th>
            </tr>
          </thead>
          <tbody data-id="element-29" data-mp="4spvfdpan24l">
            {regions.map((region, i) => <tr key={region.name} className="border-b border-line" data-id="element-30" data-mp="9o55duk6kdvq" data-mpi={i}>
                <th scope="row" className="py-4 pr-4 font-medium" data-id="element-31" data-mp="eo006972tnm2">{region.name}</th>
                <td className="hidden w-2/5 py-4 pr-6 sm:table-cell" data-id="element-32" data-mp="jncjwl2niekf">
                  <div className="flex items-center gap-3" data-id="element-33" data-mp="jljm7va0n4ok">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-line" data-id="element-34" data-mp="2ggxuyakeyq9n">
                      <motion.div className="h-full rounded-full bg-accent" initial={{
                    width: 0
                  }} whileInView={{
                    width: `${region.taskers / max * 100}%`
                  }} viewport={{
                    once: true,
                    margin: '-60px'
                  }} transition={{
                    duration: 0.3,
                    ease: [0.23, 1, 0.32, 1],
                    delay: i * 0.06
                  }} data-id="element-35" data-mp="2le7jlnzzaxwf" />
                    </div>
                    <span className="w-14 text-right font-mono text-sm tabular-nums" data-id="element-36" data-mp="2ifh4csr1tazl">{region.taskers.toLocaleString()}</span>
                  </div>
                </td>
                <td className="py-4 text-right font-mono text-sm tabular-nums" data-id="element-37" data-mp="2rdaybx1cbsjl">{region.countries}</td>
                <td className="py-4 text-right font-mono text-sm tabular-nums" data-id="element-38" data-mp="361nlq5md432h">{region.medianAccept}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}